import { IProduct } from "../../types/product";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';
import PreviousIcon from "../../assets/icons/PreviousIcon";
import NextIcon from "../../assets/icons/NextIcon";
const SlideProductOther = ({ products }: { products: IProduct[] }) => {
    return (
        <div className="w-full max-w-[1200px] mx-auto mt-4">
            <h1 className="text-xl font-semibold mb-4 uppercase">Sản phẩm khác</h1>
            <Swiper
                modules={[Navigation, Autoplay]}
                spaceBetween={20}
                slidesPerView={4}
                autoplay
                breakpoints={{
                    320: { slidesPerView: 1 },  // Mobile nhỏ
                    480: { slidesPerView: 2 },  // Mobile lớn
                    768: { slidesPerView: 3 },  // Tablet
                    1024: { slidesPerView: 4 }, // Desktop   
                }}
                navigation={{
                    nextEl: ".custom-next",
                    prevEl: ".custom-prev",
                }}
            >
                {products.map((product) => (
                    <SwiperSlide key={product.id}>
                        <a href={"/product/" + product.slug} className="block bg-white rounded-lg  overflow-hidden">
                            <img
                                src={product.photos && product.photos.length > 0
                                    ? product.photos[0]
                                    : "http://static.salekit.com/public/images/no-image.png"}
                                alt={product.name}
                                className="w-full h-auto aspect-square rounded object-contain overflow-hidden"
                            />
                            <div className="p-4 text-center">
                                <h2 className="font-normal text-base text-[#333333] truncate">{product.name}</h2>
                                <div className="flex items-end justify-center gap-3 mt-2">
                                    <p className="text-xl font-bold">{product.price_sale && product.price_sale.toLocaleString("vi-VN") + "₫"}</p>
                                    <span className="line-through text-sm text-gray-400">{product.unit_price && product.unit_price.toLocaleString("vi-VN") + "₫"}</span>
                                </div>
                            </div>
                        </a>
                    </SwiperSlide>
                ))}
                <button className="custom-prev bg-white absolute left-0 top-1/2  -translate-y-1/2 z-[1000] p-2 rounded-full shadow-md">
                    <PreviousIcon />
                </button>
                <button className="custom-next bg-white absolute right-0 top-1/2 -translate-y-1/2  z-[1000] p-2 rounded-full shadow-md">
                    <NextIcon />
                </button>
            </Swiper>
        </div>
    )
};
export default SlideProductOther;